import {
  StockOrderHead,
  StockOrderSettingsProductCreateContent,
} from "../components";

export function StockOrderingSettingsCreateProductsPage() {
  return (
    <>
      <StockOrderHead
        StockOrderBreadCrumbsProps={{
          home: {
            title: "Home",
            url: "/admin/material/order",
          },
          className: "lg:h-[200px]",
          pageTitles: [
            {
              name: "All Products",
              url: "/admin/material/settings/products",
            },
            {
              name: "Create New Product",
              url: "/admin/material/settings/products/create",
            },
          ],
        }}
      />
      <div className="p-8">
        <StockOrderSettingsProductCreateContent />
      </div>
    </>
  );
}
